import './theme-picker.css'

import React, { Component } from 'react'
import axios from 'axios'

const API_URL = process.env.REACT_APP_API_URL

function getAuthHeaders() {
  try {
    const data = JSON.parse(localStorage.getItem('resumeData') || '{}')
    if (data.psw) return { psw: data.psw }
    if (data.token) return { authorization: data.token }
  } catch (e) {
    // ignore
  }
  return {}
}

class ThemePickerComponent extends Component {
  constructor(props) {
    super(props)

    this.state = {
      themes: [],
      selectedTheme: props.theme || null,
      selectedStyle: props.style || null,
      loading: false,
      error: null,
    }
  }

  componentDidMount() {
    this.fetchThemes()
  }

  fetchThemes = () => {
    axios
      .get(`${API_URL}/resume/themes`)
      .then(response => {
        this.setState({ themes: response.data })
      })
      .catch(() => {
        // silently fail — the picker just won't show options
      })
  }

  selectTheme = themeId => {
    if (themeId === this.state.selectedTheme) return

    const theme = this.state.themes.find(t => String(t._id) === String(themeId))
    if (!theme) return

    // Pick the default style for this theme, or fall back to first
    const defaultStyle = theme.styles.find(s => s.default) || theme.styles[0]
    if (!defaultStyle) return

    this.setState(
      { selectedTheme: themeId, selectedStyle: String(defaultStyle._id) },
      () => this.applyThemeAndStyle(themeId, String(defaultStyle._id)),
    )
  }

  selectStyle = styleId => {
    if (styleId === this.state.selectedStyle) return

    this.setState({ selectedStyle: styleId }, () =>
      this.applyThemeAndStyle(this.state.selectedTheme, styleId),
    )
  }

  applyThemeAndStyle = (themeId, styleId) => {
    const { hash, onPreviewRefresh } = this.props
    const headers = getAuthHeaders()

    this.setState({ loading: true, error: null })

    axios
      .patch(
        `${API_URL}/resume/${hash}/theme`,
        { theme: themeId, style: styleId },
        { headers },
      )
      .then(() => {
        return axios.get(`${API_URL}/resume/${hash}/preview-html`, {
          headers,
          responseType: 'blob',
        })
      })
      .then(response => {
        const htmlUrl = URL.createObjectURL(response.data)
        this.setState({ loading: false })
        if (onPreviewRefresh) onPreviewRefresh(htmlUrl)
      })
      .catch(() => {
        this.setState({ loading: false, error: 'Could not apply theme. Please try again.' })
      })
  }

  getStylesForSelectedTheme = () => {
    const { themes, selectedTheme } = this.state
    const theme = themes.find(t => String(t._id) === String(selectedTheme))
    return theme ? theme.styles : []
  }

  render() {
    const { themes, selectedTheme, selectedStyle, loading, error } = this.state
    const styles = this.getStylesForSelectedTheme()

    const { compact } = this.props

    return (
      <div className={`theme-picker${compact ? ' theme-picker--compact' : ''}`}>
        {!compact && (
          <div className="theme-picker-title">
            Resume theme
            {loading && <span className="theme-picker-loading"> Updating...</span>}
          </div>
        )}

        {error && <div className="theme-picker-error">{error}</div>}

        <div className="theme-picker-themes">
          {themes.map(theme => (
            <div
              key={theme._id}
              className={`theme-card ${String(theme._id) === String(selectedTheme) ? 'theme-card--active' : ''}`}
              onClick={() => this.selectTheme(String(theme._id))}
            >
              <div className="theme-card-name">
              {theme.name}
              {compact && loading && String(theme._id) === String(selectedTheme) && (
                <span className="theme-picker-loading"> …</span>
              )}
            </div>
            </div>
          ))}
        </div>

        {styles.length > 1 && (
          <div className="theme-picker-styles">
            <div className="theme-picker-styles-label">Style</div>
            <div className="theme-picker-style-list">
              {styles.map((style, index) => (
                <div
                  key={style._id}
                  className={`style-pill ${String(style._id) === String(selectedStyle) ? 'style-pill--active' : ''}`}
                  onClick={() => this.selectStyle(String(style._id))}
                  title={style.name}
                >
                  <span
                    className="style-pill-swatch"
                    style={{ background: SWATCH_COLORS[index % SWATCH_COLORS.length] }}
                  />
                  <span className="style-pill-name">{style.name}</span>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    )
  }
}

// Visual accent colors for style swatches — purely decorative
const SWATCH_COLORS = ['#4F7FFF', '#7B52FF', '#FF6B6B', '#36C197']

export default ThemePickerComponent
